import { isEmpty } from 'lodash'

// if has token, we assume that user is logged in our system
export const isLogged = ({ token }) => !isEmpty(token)

// get current user data
export const currentUser = ({ user }) => user

// get current user data
export const getToken = ({ token }) => token

export const getGSK = ({gsk}) => gsk

export const getColorTheme = ({ colorTheme }) => colorTheme
// get current user data
export const getPermissions = ({ permissions }) => {
  return permissions
}

// get current tenant data
export const currentTenant = ({ currentTenant }) => currentTenant

// get current account data
export const currentAccount = ({ currentAccount }) => {
  if (!currentAccount) {
    console.error('Estamos sem CurrentAccount')
  }
  return currentAccount
}

export const getAccounts = ({ tenants }) => {
  // 
  // 
  // if (isEmpty(tenants)) {
  //   return null
  // } else { '
  // }
  // 
  if (typeof tenants === 'undefined') {
    return {}
  } else {
    return tenants[0].accounts.data
  }
}

export const getTenants = ({ tenants }) => {
  return tenants
}

export const getAmountAccounts = ({ amountAccounts }) => {
  return amountAccounts
}

// then survey ?
export const getSurvey = ({ survey }) => survey
